<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Travel Area Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.area }}</td>
            <td class="text-xs-left">{{ props.item.description }}</td>
            <td class="text-xs-left">{{ props.item.ranking }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['travelRatingReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Travel Area
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="areaDialog" width="800px" lazy v-if="checkAccess(['travelRatingReview'])" persistent >
        <area-dialog :areaForm="areaForm" @close="doClose" :newArea="newArea"></area-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Travel Area? ({{deleteTravelArea}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import AreaDialog from './AreaDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Travel Area Code', align: 'left', value: 'area' },
        { text: 'Travel Area Description', align: 'left', value: 'description' },
        { text: 'Travel Area Ranking', align: 'left', value: 'ranking' }
      ],
      areaForm: {
        area: undefined,
        description: undefined,
        ranking: undefined
      },
      areaDialog: undefined,
      newArea: undefined,
      loading: false,
      pagination: {
        sortBy: 'ranking'
      },
      promptRemove: false,
      selectedTravelArea: undefined,
      deleteTravelArea: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.travel.menu.getTravelAreas
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((TravelArea) => {
              const convertTravelArea = {
                area: TravelArea.area,
                description: TravelArea.description,
                ranking: TravelArea.ranking
              }
              this.items.push(convertTravelArea)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(Area) {
      const apiURI = this.$store.state.travel.menu.getTravelArea
      const expand = {
        area: Area.item.area
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.areaForm.area = data.area.area
          this.areaForm.description = data.area.description
          this.areaForm.ranking = data.area.ranking
        }
        this.areaDialog = true
      }
    },
    doClose() {
      this.areaDialog = false
      this.newArea = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.areaDialog = true
      this.newArea = true
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTravelArea = data
        this.deleteTravelArea = data.area + ' - ' + data.description
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.travel.menu.deleteTravelArea
      if (apiURI) {
        this.loading = true
        const expand = {
          area: this.selectedTravelArea.area
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['travelRatingReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    AreaDialog: AreaDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
